/**
 * @file index.tsx
 *
 * @fileoverview Renders a custom top job icon (not used by default as its null).
 */

import { Job } from '~/jobiqo/types/types';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { TrophyIcon } from '~/vcl/icons/Trophy';

interface JobTopJobIconSlotProps {
  /**
   * The job to render the icon for.
   */
  job: Slottable<Job>;
  /**
   * The width of the icon.
   */
  width?: string;
  /**
   * The height of the icon.
   */
  height?: string;
}

export default function JobTopJobIconSlot({
  job,
  width,
  height,
}: JobTopJobIconSlotProps) {
  return (
    <TrophyIcon {...(width ? { width } : {})} {...(height ? { height } : {})} />
  );
}
export { JobTopJobIconSlot };
